import { useEffect } from 'react';

import { httpService, resolveContextCommunity } from '@flexo/general';
import { ALERT, KPI, METADATA, store } from '@flexo/reducers';
import { _navigate } from './helpers';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

const ENV = (import.meta as any).env;

export const MemberResolver = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const pathSegment = location.pathname.split('/')[1];

  async function MemberInit(fromCommunity?: string | null) {
    if (!pathSegment?.includes('member')) {
      return;
    }

    // Token auto-injected by httpService interceptor
    const [member] = await Promise.all([
      httpService
        .get({
          // url: `/community/catalog/v1/catalog/community/${globalDataStore.data?.communityID}/members/${globalDataStore.navigation?.id}`,
          url: `${ENV.VITE_APP_BASE_URL}/community/catalog/v1_3/member/${params.id}`,
          // /community/catalog/v1_3/member/{memberId}
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {
            // console.warn({
            //   status: res.status,
            //   message: res.statusText
            // });
            return null;
          }
        })

        .catch((err: any) => {
          // console.warn(err);

          dispatch(ALERT.SetAlert({
            value: {
              type: 'BANNER_UNEXPECTED_ERROR',
            },
          } as any));

          return null;
        }),
    ]);

    // FLEXO-6114: pin the member's community context to the one the user
    // navigated from. The `/member/{id}` API returns an arbitrary `communityId`
    // (max(end_date), no tie-break) for multi-community members; overriding it
    // here with `resolveContextCommunity` fixes every consumer that reads
    // `selectedEntity.communityId` (footer, community-stats, details list,
    // feedback) in one place. Falls back to the API scalar when there is no
    // source context / no changelog match (deep-link).
    const sp = new URLSearchParams(window?.location?.search || '');
    const dateFrom =
      sp.get('dateFrom') || new Date().toISOString().slice(0, 10);
    const visibleSiteIds = new Set<string>(
      ((store.getState() as any)?.metadata?.entities?.site || [])
        .map((s: any) => s?.siteId)
        .filter(Boolean)
    );
    const contextCommunityId = member
      ? resolveContextCommunity(member, {
          fromCommunity,
          dateFrom,
          visibleSiteIds,
        })
      : null;
    const patchedMember =
      member && contextCommunityId
        ? { ...member, communityId: contextCommunityId }
        : member;

    dispatch(
      METADATA.SetSelectedEntity({
        selectedEntity: patchedMember,
        id: patchedMember?.memberId,
        entityType: 'member',
      } as any)
    );
  }

  useEffect(() => {
    // FLEXO-6114: capture the community-of-origin from the route, store it as an
    // ephemeral nav-context, then strip `fromCommunity` from the URL so it is
    // used only for THIS navigation — never persisted, shared or carried
    // forward. Loads without it reset the context to null (no leak).
    const sp = new URLSearchParams(window?.location?.search || '');
    const fromCommunity = sp.get('fromCommunity');
    dispatch(METADATA.SetNavContextCommunity(fromCommunity || null) as any);
    if (fromCommunity) {
      sp.delete('fromCommunity');
      const q = sp.toString();
      const newUrl =
        window.location.pathname + (q ? `?${q}` : '') + window.location.hash;
      window.history.replaceState(window.history.state, '', newUrl);
    }

    MemberInit(fromCommunity);
  }, [params.id]);

  return <></>;
};

export function navigateToMember(context = 'member', memberID: string, queryParamsOverride?: string) {

  const queryParams = queryParamsOverride !== undefined
    ? queryParamsOverride
    : (window?.location?.search || '');
  const dispatch = store.dispatch;
  const location = window.location;
  const pathSegment = location.pathname.split('/')[2];

  dispatch(KPI.ResetKpiFields());

  if (ENV?.VITE_APP_IS_WEB === 'true' && context === 'member') {
  //   const D = luxon.DateTime.now().startOf('day').toJSDate();
  //   const D2 = luxon.DateTime.now().plus({ days: 1 }).startOf('day').toJSDate();

  //   dispatch(
  //     CALENDAR.setHiveDate({
  //       date: [D, D2],
  //       timeSet: 'day',
  //       setQueryParams: false,
  //     } as any)
  //   );
  }

  dispatch(METADATA.SetPrevSelectedEntityId(pathSegment as any));

  _navigate(`/${context}/${memberID}${queryParams}`);

}
